document.addEventListener('DOMContentLoaded', () => {
  const drawerToggle = document.querySelector('[data-drawer-toggle]');
  const drawer = document.querySelector('[data-mobile-drawer]');

  if (drawerToggle && drawer) {
    drawerToggle.addEventListener('click', () => {
      const expanded = drawerToggle.getAttribute('aria-expanded') === 'true';
      drawerToggle.setAttribute('aria-expanded', String(!expanded));
      drawer.classList.toggle('is-open', !expanded);
      document.body.classList.toggle('cart-open', !expanded);
    });
  }

  document.querySelectorAll('[data-collection-tabs]').forEach((tabGroup) => {
    const triggers = [...tabGroup.querySelectorAll('[data-tab-trigger]')];
    const panels = [...tabGroup.querySelectorAll('[data-tab-panel]')];

    const activateTab = (tabId) => {
      triggers.forEach((trigger) => {
        const isActive = trigger.dataset.tabTrigger === tabId;
        trigger.classList.toggle('is-active', isActive);
        trigger.setAttribute('aria-selected', String(isActive));
      });

      panels.forEach((panel) => {
        panel.classList.toggle('is-active', panel.dataset.tabPanel === tabId);
      });
    };

    triggers.forEach((trigger) => {
      trigger.addEventListener('click', () => activateTab(trigger.dataset.tabTrigger));
    });
  });

  document.querySelectorAll('[data-hero]').forEach((hero) => {
    const track = hero.querySelector('[data-hero-track]');
    const slides = track ? [...track.children] : [];
    if (!track || slides.length < 2) return;

    const dots = [...hero.querySelectorAll('[data-hero-dot]')];
    const prev = hero.querySelector('[data-hero-prev]');
    const next = hero.querySelector('[data-hero-next]');
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let index = 0;
    let timer = null;

    const go = (n) => {
      index = (n + slides.length) % slides.length;
      track.style.transform = 'translateX(-' + index * 100 + '%)';
      dots.forEach((d, di) => d.classList.toggle('is-active', di === index));
    };
    const stop = () => {
      if (timer) clearInterval(timer);
      timer = null;
    };
    const start = () => {
      if (reduce) return;
      stop();
      timer = setInterval(() => go(index + 1), 6000);
    };

    if (prev) prev.addEventListener('click', () => { go(index - 1); start(); });
    if (next) next.addEventListener('click', () => { go(index + 1); start(); });
    dots.forEach((d, di) => d.addEventListener('click', () => { go(di); start(); }));
    hero.addEventListener('mouseenter', stop);
    hero.addEventListener('mouseleave', start);

    go(0);
    start();
  });

  document.querySelectorAll('[data-gallery]').forEach((gallery) => {
    const track = gallery.querySelector('[data-gallery-track]');
    if (!track) return;
    const allSlides = [...track.children];
    if (allSlides.length === 0) return;
    const indexLabel = gallery.querySelector('[data-gallery-index]');
    const totalLabel = gallery.querySelector('[data-gallery-total]');
    const prev = gallery.querySelector('[data-gallery-prev]');
    const next = gallery.querySelector('[data-gallery-next]');

    let slides = allSlides;
    let pos = 0;
    const layout = () => {
      track.style.transform = 'translateX(-' + pos * 100 + '%)';
      if (indexLabel) indexLabel.textContent = String(slides.length ? pos + 1 : 0);
      if (totalLabel) totalLabel.textContent = String(slides.length);
    };
    const goTo = (i) => {
      if (!slides.length) return;
      pos = (i + slides.length) % slides.length;
      layout();
    };
    // Existing callers pass an index into the full media list.
    const goToMedia = (fullIdx) => {
      if (fullIdx == null) return;
      const el = allSlides[fullIdx];
      const ai = el ? slides.indexOf(el) : -1;
      goTo(ai >= 0 ? ai : 0);
    };
    const filterByFit = (fit) => {
      const f = fit ? String(fit).toLowerCase() : '';
      let matched = allSlides.filter((s) => !s.dataset.fit || (f && s.dataset.fit === f));
      if (f && !matched.some((s) => s.dataset.fit === f)) matched = allSlides;
      if (!matched.length) matched = allSlides;
      allSlides.forEach((s) => {
        s.style.display = matched.indexOf(s) >= 0 ? '' : 'none';
      });
      slides = matched;
      pos = 0;
      layout();
    };
    if (prev) prev.addEventListener('click', () => goTo(pos - 1));
    if (next) next.addEventListener('click', () => goTo(pos + 1));
    gallery.galleryGoTo = goToMedia;
    gallery.galleryFilterFit = filterByFit;
    layout();
  });

  document.querySelectorAll('[data-product-form]').forEach((productForm) => {
    const gallery = productForm.closest('[data-gallery]') || document.querySelector('[data-gallery]');
    const variantInput = productForm.querySelector('input[name="id"]');
    const optionGroups = [...productForm.querySelectorAll('[data-option-position]')];
    const variantDataNode = productForm.querySelector('[data-product-variants]');
    const priceNode = document.querySelector(`[data-product-price="${productForm.dataset.sectionId}"]`);
    const submitButton = productForm.querySelector('[data-add-button]');
    const dynamic = productForm.querySelector('[data-dynamic-checkout]');

    if (!variantInput || !variantDataNode) return;

    let variants = [];
    try {
      variants = JSON.parse(variantDataNode.textContent);
    } catch (e) {
      return;
    }

    const getSelected = () =>
      optionGroups.map((group) => {
        const checked = group.querySelector('input[data-product-option]:checked');
        return checked ? checked.value : null;
      });

    const renderPrice = (variant) => {
      if (!priceNode) return;
      if (variant.compare_at) {
        priceNode.classList.add('is-sale');
        priceNode.innerHTML = '<del>' + variant.compare_at + '</del><span>' + variant.price + '</span>';
      } else {
        priceNode.classList.remove('is-sale');
        priceNode.innerHTML = '<span>' + variant.price + '</span>';
      }
    };

    const refreshAvailability = (selected) => {
      optionGroups.forEach((group, gi) => {
        group.querySelectorAll('input[data-product-option]').forEach((input) => {
          const trial = selected.slice();
          trial[gi] = input.value;
          const exists = variants.some(
            (v) => v.available && v.options.every((o, i) => trial[i] == null || o === trial[i])
          );
          if (input.nextElementSibling) {
            input.nextElementSibling.classList.toggle('is-unavailable', !exists);
          }
        });
      });
    };

    const updateOptionLabels = (selected) => {
      optionGroups.forEach((group, gi) => {
        const cur = group.querySelector('[data-option-current]');
        if (cur) cur.textContent = selected[gi] ? ': ' + selected[gi] : '';
      });
    };

    const setButton = (text, disabled) => {
      if (!submitButton) return;
      submitButton.textContent = text;
      submitButton.disabled = disabled;
    };

    const syncVariant = () => {
      const selected = getSelected();
      refreshAvailability(selected);
      updateOptionLabels(selected);

      const allChosen = selected.every((v) => v !== null);
      const match =
        optionGroups.length === 0
          ? variants[0]
          : variants.find((v) => v.options.every((o, i) => o === selected[i]));

      if (optionGroups.length > 0 && !allChosen) {
        const partial = variants.find((v) =>
          v.options.every((o, i) => selected[i] == null || o === selected[i])
        );
        if (partial) {
          renderPrice(partial);
          if (gallery && typeof gallery.galleryGoTo === 'function' && partial.media != null) {
            gallery.galleryGoTo(partial.media);
          }
        }
        setButton('Vælg størrelse', true);
        if (dynamic) dynamic.classList.add('is-hidden');
        return;
      }

      if (!match) {
        setButton('Udsolgt', true);
        if (dynamic) dynamic.classList.add('is-hidden');
        return;
      }

      variantInput.value = match.id;
      renderPrice(match);

      if (match.available) {
        setButton('Læg i kurv', false);
        if (dynamic) dynamic.classList.remove('is-hidden');
      } else {
        setButton('Udsolgt', true);
        if (dynamic) dynamic.classList.add('is-hidden');
      }

      if (gallery && typeof gallery.galleryGoTo === 'function' && match.media != null) {
        gallery.galleryGoTo(match.media);
      }

      const url = new URL(window.location.href);
      url.searchParams.set('variant', match.id);
      window.history.replaceState({}, '', url.toString());
    };

    productForm
      .querySelectorAll('input[data-product-option]')
      .forEach((input) => input.addEventListener('change', syncVariant));
    syncVariant();

    /* ---- Men/Women fit toggle ---- */
    const fitToggle = gallery && gallery.querySelector('[data-fit-toggle]');
    if (fitToggle) {
      const fitInputs = [
        ...productForm.querySelectorAll('[data-fit-inputs] input[data-product-option]'),
      ];
      const fitButtons = [...fitToggle.querySelectorAll('[data-fit-value]')];
      const applyFit = (value) => {
        fitButtons.forEach((b) => {
          const on = b.dataset.fitValue === value;
          b.classList.toggle('is-active', on);
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        if (gallery && typeof gallery.galleryFilterFit === 'function') {
          gallery.galleryFilterFit(value);
        }
      };
      fitButtons.forEach((btn) => {
        btn.addEventListener('click', () => {
          const value = btn.dataset.fitValue;
          applyFit(value);
          const radio = fitInputs.find((i) => i.value === value);
          if (radio && !radio.checked) {
            radio.checked = true;
            radio.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
      });
      const checked = fitInputs.find((i) => i.checked) || fitInputs[0];
      if (checked) applyFit(checked.value);
    }
  });

  /* ---- Size guide modal ---- */
  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-size-guide-open]');
    if (opener) {
      const root = document.querySelector('[data-size-guide]');
      if (root) {
        root.hidden = false;
        document.body.classList.add('cart-open');
      }
      return;
    }
    if (e.target.closest('[data-size-guide-close]')) {
      const root = document.querySelector('[data-size-guide]');
      if (root) {
        root.hidden = true;
        document.body.classList.remove('cart-open');
      }
    }
  });

  /* ---- Cart drawer (progressive enhancement) ---- */
  const cartDrawer = document.querySelector('[data-cart-drawer]');

  const setCartCount = () => {
    const drawerEl = document.querySelector('[data-cart-drawer]');
    if (!drawerEl) return;
    const title = drawerEl.querySelector('.cart-drawer__title');
    if (!title) return;
    const m = title.textContent.match(/\d+/);
    if (m) {
      document.querySelectorAll('[data-cart-count]').forEach((n) => {
        n.textContent = m[0];
      });
    }
  };

  const openDrawer = () => {
    if (!cartDrawer) return;
    cartDrawer.classList.add('is-open');
    cartDrawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cart-open');
  };
  const closeDrawer = () => {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('is-open');
    cartDrawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cart-open');
  };

  const renderCart = (html) => {
    const live = document.querySelector('[data-cart-content]');
    if (!live) return;
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const fresh = doc.querySelector('[data-cart-content]');
    if (fresh) {
      live.innerHTML = fresh.innerHTML;
      setCartCount();
    }
  };

  if (cartDrawer) {
    document.querySelectorAll('[data-cart-open]').forEach((el) => {
      el.addEventListener('click', (e) => {
        e.preventDefault();
        openDrawer();
      });
    });

    cartDrawer.addEventListener('click', (e) => {
      if (e.target.closest('[data-cart-close]')) {
        e.preventDefault();
        closeDrawer();
        return;
      }
      const remove = e.target.closest('[data-cart-remove]');
      const minus = e.target.closest('[data-cart-minus]');
      const plus = e.target.closest('[data-cart-plus]');
      if (!remove && !minus && !plus) return;

      const row = e.target.closest('[data-line]');
      if (!row) return;
      const line = parseInt(row.getAttribute('data-line'), 10);
      let quantity = 0;
      if (minus || plus) {
        const qtyEl = row.querySelector('[data-qty]');
        const current = qtyEl ? parseInt(qtyEl.textContent, 10) || 1 : 1;
        quantity = plus ? current + 1 : Math.max(0, current - 1);
      }

      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          line,
          quantity,
          sections: 'cart-drawer',
          sections_url: window.location.pathname
        })
      })
        .then((r) => r.json())
        .then((data) => {
          if (data && data.sections && data.sections['cart-drawer']) {
            renderCart(data.sections['cart-drawer']);
          }
        })
        .catch(() => {});
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        closeDrawer();
        const sg = document.querySelector('[data-size-guide]');
        if (sg && !sg.hidden) {
          sg.hidden = true;
          document.body.classList.remove('cart-open');
        }
      }
    });

    document.querySelectorAll('[data-product-form]').forEach((form) => {
      form.addEventListener('submit', (e) => {
        if (!e.submitter || !e.submitter.matches('[data-add-button]')) return;
        e.preventDefault();
        const formData = new FormData(form);
        formData.append('sections', 'cart-drawer');
        formData.append('sections_url', window.location.pathname);
        const btn = e.submitter;
        const original = btn.textContent;
        btn.disabled = true;
        btn.textContent = 'Tilføjer…';

        fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: formData })
          .then((r) => {
            if (!r.ok) throw new Error('add failed');
            return r.json();
          })
          .then((data) => {
            if (data && data.sections && data.sections['cart-drawer']) {
              renderCart(data.sections['cart-drawer']);
            }
            btn.textContent = original;
            btn.disabled = false;
            openDrawer();
          })
          .catch(() => {
            form.submit();
          });
      });
    });
  }

  /* ---- Reveal on scroll ---- */
  const main = document.getElementById('MainContent');
  if (main && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-revealed');
            io.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -8% 0px' }
    );
    [...main.children].forEach((el, i) => {
      if (i === 0) return;
      el.setAttribute('data-reveal', '');
      io.observe(el);
    });
  }

  /* ---- Wishlist (local, visual) ---- */
  const WISH_KEY = 'bnf_wish';
  const getWish = () => {
    try {
      return JSON.parse(localStorage.getItem(WISH_KEY) || '[]');
    } catch (e) {
      return [];
    }
  };
  document.querySelectorAll('[data-wish]').forEach((btn) => {
    const id = btn.getAttribute('data-wish-id');
    if (!id) return;
    if (getWish().indexOf(id) !== -1) {
      btn.classList.add('is-saved');
      btn.setAttribute('aria-pressed', 'true');
    }
    btn.addEventListener('click', () => {
      let list = getWish();
      const on = list.indexOf(id) !== -1;
      list = on ? list.filter((x) => x !== id) : list.concat(id);
      try {
        localStorage.setItem(WISH_KEY, JSON.stringify(list));
      } catch (e) {}
      btn.classList.toggle('is-saved', !on);
      btn.setAttribute('aria-pressed', String(!on));
    });
  });

  /* ---- Mega-menu hover intent (close delay bridges the transit gap) ---- */
  document.querySelectorAll('.nav__item--mega').forEach((item) => {
    let closeTimer = null;
    const open = () => {
      clearTimeout(closeTimer);
      item.classList.add('is-open');
    };
    const scheduleClose = () => {
      clearTimeout(closeTimer);
      closeTimer = setTimeout(() => item.classList.remove('is-open'), 280);
    };
    item.addEventListener('mouseenter', open);
    item.addEventListener('mouseleave', scheduleClose);
    item.addEventListener('focusin', open);
    item.addEventListener('focusout', (e) => {
      if (!item.contains(e.relatedTarget)) scheduleClose();
    });
  });

  /* ---- Recently viewed ---- */
  const RV_KEY = 'bnf_recent';
  const rvCurrent = document.querySelector('[data-rv-current]');
  if (rvCurrent) {
    try {
      const item = JSON.parse(rvCurrent.textContent);
      let list = [];
      try {
        list = JSON.parse(localStorage.getItem(RV_KEY) || '[]');
      } catch (e) {
        list = [];
      }
      list = list.filter((x) => x && x.url !== item.url);
      list.unshift(item);
      list = list.slice(0, 8);
      localStorage.setItem(RV_KEY, JSON.stringify(list));
    } catch (e) {}
  }
  document.querySelectorAll('[data-rv-list]').forEach((wrap) => {
    let list = [];
    try {
      list = JSON.parse(localStorage.getItem(RV_KEY) || '[]');
    } catch (e) {
      list = [];
    }
    const here = wrap.getAttribute('data-rv-exclude') || '';
    list = list.filter((x) => x && x.url !== here).slice(0, 5);
    if (!list.length) return;
    const section = wrap.closest('[data-rv-section]');
    wrap.innerHTML = list
      .map(
        (p) =>
          '<a class="rv-card" href="' +
          p.url +
          '"><span class="rv-card__img">' +
          (p.image ? '<img src="' + p.image + '" alt="" loading="lazy">' : '') +
          '</span><span class="rv-card__title">' +
          (p.title || '') +
          '</span><span class="rv-card__price">' +
          (p.price || '') +
          '</span></a>'
      )
      .join('');
    if (section) section.hidden = false;
  });

  /* ---- Predictive search ---- */
  const searchRoot = document.querySelector('[data-search]');
  if (searchRoot) {
    const input = searchRoot.querySelector('[data-search-input]');
    const results = searchRoot.querySelector('[data-search-results]');
    const openSearch = () => {
      searchRoot.classList.add('is-open');
      document.body.classList.add('cart-open');
      setTimeout(() => input && input.focus(), 60);
    };
    const closeSearch = () => {
      searchRoot.classList.remove('is-open');
      document.body.classList.remove('cart-open');
    };
    document.querySelectorAll('[data-search-open]').forEach((b) =>
      b.addEventListener('click', (e) => {
        e.preventDefault();
        openSearch();
      })
    );
    searchRoot.addEventListener('click', (e) => {
      if (e.target.closest('[data-search-close]')) closeSearch();
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && searchRoot.classList.contains('is-open')) closeSearch();
    });
    let t = null;
    if (input && results) {
      input.addEventListener('input', () => {
        clearTimeout(t);
        const q = input.value.trim();
        if (q.length < 2) {
          results.innerHTML = '';
          return;
        }
        t = setTimeout(() => {
          fetch(
            '/search/suggest.json?q=' +
              encodeURIComponent(q) +
              '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last'
          )
            .then((r) => r.json())
            .then((data) => {
              const items =
                (data.resources && data.resources.results && data.resources.results.products) || [];
              if (!items.length) {
                results.innerHTML = '<p class="search-drawer__empty">Ingen resultater for "' + q + '"</p>';
                return;
              }
              results.innerHTML = items
                .map((p) => {
                  const img =
                    p.image || (p.featured_image && p.featured_image.url) || '';
                  return (
                    '<a class="search-drawer__item" href="' +
                    p.url +
                    '"><span class="search-drawer__thumb">' +
                    (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') +
                    '</span><span class="search-drawer__meta"><span class="search-drawer__name">' +
                    p.title +
                    '</span><span class="search-drawer__price">' +
                    (p.price || '') +
                    '</span></span></a>'
                  );
                })
                .join('');
            })
            .catch(() => {});
        }, 220);
      });
    }
  }

  /* ---- Desktop sticky add-to-cart ---- */
  const stickyBar = document.querySelector('[data-sticky-atc]');
  const stickyAnchor = document.querySelector('[data-add-button]');
  if (stickyBar && stickyAnchor && 'IntersectionObserver' in window) {
    const so = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          stickyBar.classList.toggle('is-visible', !entry.isIntersecting);
        });
      },
      { rootMargin: '-120px 0px 0px 0px' }
    );
    so.observe(stickyAnchor);
    const sBtn = stickyBar.querySelector('[data-sticky-add]');
    if (sBtn) {
      sBtn.addEventListener('click', () => {
        stickyAnchor.click();
      });
    }
  }

  /* ---- Header locale switcher (circular flag → centered modal) ---- */
  const localeModal = document.querySelector('[data-locale-modal]');
  const localeToggles = document.querySelectorAll('[data-locale-toggle]');
  if (localeModal && localeToggles.length) {
    const dialog = localeModal.querySelector('[data-locale-panel]');
    const overlay = localeModal.querySelector('.locale-modal__overlay');
    const country = localeModal.querySelector('[data-locale-country]');
    const closeEls = localeModal.querySelectorAll('[data-locale-close]');
    const closeBtn = localeModal.querySelector('.locale-modal__close');

    const setOpen = (open) => {
      if (dialog) dialog.hidden = !open;
      if (overlay) overlay.hidden = !open;
      localeToggles.forEach((t) => t.setAttribute('aria-expanded', String(open)));
      document.body.classList.toggle('cart-open', open);
      if (open) {
        if (closeBtn) closeBtn.focus();
      } else if (localeToggles[0]) {
        localeToggles[0].focus();
      }
    };

    localeToggles.forEach((t) =>
      t.addEventListener('click', () => setOpen(dialog ? dialog.hidden : true))
    );
    closeEls.forEach((el) => el.addEventListener('click', () => setOpen(false)));

    // Changing country auto-matches the language (currency follows the
    // market automatically) and submits both in one localization request.
    if (country && country.form) {
      country.addEventListener('change', () => {
        const opt = country.selectedOptions && country.selectedOptions[0];
        const langField = country.form.querySelector('[data-locale-langfield]');
        if (langField && opt && opt.dataset.locale) {
          langField.value = opt.dataset.locale;
        }
        country.form.submit();
      });
    }

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && dialog && !dialog.hidden) setOpen(false);
    });
  }

  /* ---- Validation landing: marshal radio votes into customer tags + note ---- */
  document.querySelectorAll('#ValidationForm').forEach((form) => {
    const tagsInput = form.querySelector('[data-validation-tags]');
    const noteInput = form.querySelector('[data-validation-note]');
    const conceptInput = form.querySelector('[data-validation-concept]');
    if (!tagsInput) return;

    const slug = (s) =>
      s
        .toLowerCase()
        .normalize('NFD')
        .replace(/[̀-ͯ]/g, '')
        .replace(/[—–]/g, '-')
        .replace(/\s+/g, '-')
        .replace(/[^a-z0-9-]/g, '')
        .replace(/-+/g, '-')
        .replace(/^-|-$/g, '');

    form.addEventListener('submit', () => {
      const fields = ['color', 'would_buy'];
      const tags = ['waitlist'];
      const noteLines = [];

      if (conceptInput && conceptInput.value) {
        tags.push(slug(conceptInput.value));
        noteLines.push(`concept: ${conceptInput.value}`);
      }

      fields.forEach((name) => {
        const checked = form.querySelector(`input[name="vote_${name}"]:checked`);
        if (checked) {
          const val = checked.value.trim();
          tags.push(`${name}:${slug(val)}`);
          noteLines.push(`${name}: ${val}`);
        }
      });

      tagsInput.value = tags.join(', ');
      if (noteInput) noteInput.value = noteLines.join('\n');
    });
  });
});
